<template>
  <div class="cardWrapper">
    <v-card class="recommendedCard" :class="{ 'small': small }" elevation="0" :ripple="false" variant="flat">
    <!-- Image Section -->
    <v-img :src="imageUrl" class="imageUrl" :cover="true">
      <div class="imageContent pa-4">
        <div class="d-flex justify-space-between align-start">
          <span class="categoryText font-weight-bold">{{ category }}</span>
          <FavoriteChip 
            :isFavorited="isFavorited"
            @favorite-clicked="$emit('favorite-clicked', $event)" />
        </div>
        <v-spacer></v-spacer>
      </div>
    </v-img>

    <v-chip v-if="cardLabel" class="spendLabel" small>
      {{ cardLabel }}
    </v-chip>

    <!-- Details Section -->
    <div v-if="!small" class="pa-4 d-flex align-center">
      <div class="logoUrl">
        <img :src="merchantLogoUrl">
      </div>

      <div class="merchantInfo">
        <div class="font-weight-bold" :style="'font-size: 14px; font-weight: 500;'">{{ merchantName }}</div>
        <div class="spendInfo">{{ spendLabel }}: <span><strong>{{ spendAmount }}</strong></span></div>
      </div>

      <div class="savingsInfo text-right">
        <div class="saveText">Save <span class="font-weight-bold savingsAmount">{{ formatter.format(savingsAmount) }}</span></div>
        <div class="savingsPercentage"><strong>{{ savingsPercentage }}</strong>%</div>
      </div>
    </div>
    <div v-else class="smallDetailsSection">
      <div class="icon-col" style="">
        <img :src="merchantLogoUrl" class="icon">
      </div>
      <div class="smallDetailsContent">
        <div class="smallMerchantName">{{ merchantName }}</div>
        <div v-if="savingsAmount" class="smallSavingsAmount">{{ formatter.format(savingsAmount) }}</div>
        <div v-if="savingsPercentage && !savingsAmount" class="smallSavingsAmount">{{ savingsPercentage }}%</div>
        <div v-if="savingsPercentage && savingsAmount" class="smallSaveText">Save: <span style="font-weight: bold;">{{ savingsPercentage }}%</span></div>
      </div>
    </div>
  </v-card>
  </div>
</template>

<script>
import FavoriteChip from './FavoriteChip.vue';

export default {
  name: 'VoucherRecommendedForYou',
  components: {
    FavoriteChip
  },
  emits: ['favorite-clicked'],
  props: {
    small: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      required: false
    },
    category: {
      type: String
    },
    isFavorited: {
      type: Boolean,
      default: false
    },
    cardLabel: {
      type: String
    },
    merchantLogoUrl: {
      type: String,
      required: true
    },
    merchantName: {
      type: String,
      default: 'Merchant'
    },
    spendAmount: {
      type: String
    },
    spendLabel: {
      type: String
    },
    savingsAmount: {
      type: Number
    },
    savingsPercentage: {
      type: Number
    },
		formatter: {default: null},
  }
};
</script>

<style scoped>
.cardWrapper {
  -webkit-tap-highlight-color: transparent;
}

.recommendedCard {
  border-radius: 16px;
}

.imageContent {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5) 0%, transparent 40%), linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 50%);
}

.categoryText {
  font-size: 16px;
  color: white;
}

.spendLabel {
  background-color: rgba(255, 255, 255, 1) !important;
  align-self: flex-start;
  font-size: 11px !important;
  position: absolute;
  top: 274px;
  left: 16px;
  transform: translateY(-50%);
  z-index: 1;
}

.savingsInfo {
  margin-left: auto;
  text-align: right;
}

.imageUrl {
  height: 274px;
}

.logoUrl img {
  width: 32px !important;
  height: 32px !important;
  border-radius: 8px;
  margin-right: 16px;
  margin-top: 10px
}

.icon-col {
  margin-top: -45px;
	vertical-align: middle;
}

.icon {
	width: 65px;
	background-color: #E7ECF7;
	border-radius: 10px;
}

.recommendedCard.small {
  height: 208px;
}

.recommendedCard.small .imageUrl {
  height: 72px;
}

.recommendedCard.small .logoUrl {
  position: absolute;
  top: 72px;
  left: 16px;
  transform: translateY(-220%);
  z-index: 1;
}

.recommendedCard.small .logoUrl img {
  width: 48px;
  height: 32px;
  border-radius: 5px;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
}

.smallDetailsSection {
  padding: 16px;
  position: relative;
}

.smallDetailsContent {
  margin-top: 24px;
}

.smallMerchantName {
  margin-top: -15px;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.smallSavingsAmount {
  margin-top: 25px;
  font-size: 24px;
  font-weight: bold;
}

.smallSaveText {
  font-size: 11px;
}

.spendInfo {
  white-space: nowrap;
}
</style>
